import React from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import * as IoIcons from 'react-icons/io';

export const SidebarStaff = [
   
    {
        title: 'Customers',
        path: '/customers-list',
        icon: <IoIcons.IoMdPeople />,
        cName: 'nav-text'
    },
    {
        title: 'Companies',
        path: '/companies-list',
        icon: <AiIcons.AiTwotoneBuild />,
        cName: 'nav-text'
    },
    {
        title: 'Applications',
        path: '/applications-list',
        icon: <AiIcons.AiOutlineAccountBook />,
        cName: 'nav-text'
    }, 
    {
        title: 'Tippani',
        path: '/tippani',
        icon: <FaIcons.FaEnvelopeOpenText />,
        cName: 'nav-text'
    },
   
    {
        title: 'Chalani',
        path: '/chalani',
        icon: <IoIcons.IoIosPaper />,
        cName: 'nav-text'
    },
    {
        title: 'Progress Report',
        path: '/progress-report',
        icon: <IoIcons.IoIosPaper />,
        cName: 'nav-text'
    }
];